import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import Table from 'web-app/react/components/table/model';

export const fetchReport = (organizationId, month) =>
    RESTClient.getAuthenticatedObservable('v2/sessions/organization-reports/balances', {
        organizationId,
        month,
    }).map(response => ({
        csvLink: response.csv,
        table: Table.fromAPI(response.table),
    }));
